import AmazonAIConvertPredictionsProvider from './AmazonAIConvertPredictionsProvider';
import AmazonAIIdentifyPredictionsProvider from './AmazonAIIdentifyPredictionsProvider';
import AmazonAIInterpretPredictionsProvider from './AmazonAIInterpretPredictionsProvider';
import AmazonAIPredictionsProvider from './AmazonAIPredictionsProvider';
export { AmazonAIConvertPredictionsProvider, AmazonAIIdentifyPredictionsProvider, AmazonAIInterpretPredictionsProvider, AmazonAIPredictionsProvider, };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/predictions/lib-esm/Providers/index.js
// module id = 364
// module chunks = 0